import React from "react";

const ADPlusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clipPath="url(#clip0_1010_99849)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32 16C32 24.8366 24.8366 32 16 32C7.16345 32 0 24.8366 0 16C0 7.16345 7.16345 0 16 0C24.8366 0 32 7.16345 32 16ZM16 8.4C16.6627 8.4 17.2 8.93726 17.2 9.6V14.8H22.4C23.0627 14.8 23.6 15.3373 23.6 16C23.6 16.6627 23.0627 17.2 22.4 17.2H17.2V22.4C17.2 23.0627 16.6627 23.6 16 23.6C15.3373 23.6 14.8 23.0627 14.8 22.4V17.2H9.6C8.93726 17.2 8.4 16.6627 8.4 16C8.4 15.3373 8.93726 14.8 9.6 14.8H14.8V9.6C14.8 8.93726 15.3373 8.4 16 8.4Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1010_99849">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ADPlusIcon;
